import {supabase} from "../../../services/Supabase";

export const ReportsService = {
    get: async function(id: string) {
        let { data, error } = await supabase
            .from('reports')
            .select('*')
            .eq("id", id)
        return data
    },


    view: async function() {
        let { data, error } = await supabase
            .from('reports')
            .select('*')
        return data
    },

    create: async function(report: any) {
        const { data, error } = await supabase
            .from('reports')
            .insert([
                { id: report.id },
            ])
        return data
    },

    update: async function(id: string, report: any) {
        const { data, error } = await supabase
            .from('reports')
            .update([
                { ...report },
            ])
            .eq('id', id)
        return data
    },

    remove: async function(id: string)  {
        const { data, error } = await supabase
            .from('reports')
            .delete()
            .eq('id', id)
        return data
    }
}